<div id="app-wrapper">
  <section id="staff-warning-section" *ngIf="isDangerZone" (click)="resetOrganization()">You are on customer data.  Click here to reset.</section>
  <router-outlet></router-outlet>
</div>
